export const Arr_SummerArrivalDeparture = [
  //-------------------------------------------------------------------------
  // SummerArrivalDepartur//
  //--------------------------------------------------------------------------
  //Arrival Aiport
  {
    //0
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Airline",
    name: "Arrival_Airport_Airline",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
  },
  {
    //1
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Flight Number",
    name: "Arrival_Airport_Flight_Number",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
  },
  {
    //2
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Departure Airport",
    name: "Arrival_Airport_Departure_Airport",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
  },
  {
    //3
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Arrival Airport",
    name: "Arrival_Airport_Arrival_Airport",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
    selectValues: ["Heathrow Airport"],
  },
  {
    //4
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Arrival Terminal",
    name: "Arrival_Airport_Arrival_Terminal",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
    selectValues: ["Terminal 2", "Terminal 3", "Terminal 4", "Terminal 5"],
  },

  {
    //5
    Page: "SummerArrivalDeparture",
    TextField: "TimeFieldForObjectState",
    label: "Airport Arrival/ Landing Time",
    name: "Arrival_Airport_Arrival_Time",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
  },
  {
    //6
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Unaccompanied Minor Scheme",
    name: "Arrival_Airport_Unaccompanied_Minor_Scheme",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_Airport",
    selectValues: ["Yes", "No"],
    AboveText: (
      <p>Is the student using an airline unaccompanied minor scheme?</p>
    ),
  },

  //--------------------------------------------------------------------------
  //Arrival General

  {
    //7
    Page: "SummerArrivalDeparture",
    TextField: "TimeFieldForObjectState",
    label: "Estimated Arrival Time At Accomodation",
    name: "Arrival_General_Arrival_Time",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_General",
  },
  {
    //8
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Arrival Method",
    name: "Arrival_General_Arrival_Method",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Arrival_General",
    selectValues: [
      "Parent/ Guardian drop off",
      "Student arriving on their own",
      "Private Airport Transfer",
    ],
  },
  //If Parent/ Guardian drop off is selected, show the following fields:
  {
    //9
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Full Name of Parent/Guardian",
    name: "Arrival_General_Arrival_Parent_Guardian_Name",
    onlyAppearIfValueIs: ["Parent/ Guardian drop off"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },
  {
    //10
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Relationship to student",
    name: "Arrival_General_Arrival_Parent_Guardian_Relationship",
    onlyAppearIfValueIs: ["Parent/ Guardian drop off"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },

  //if Private Airport Transfer is selected, show the following fields:
  {
    //11
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Airline",
    name: "Arrival_General_Private_Airport_Airline",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },
  {
    //12
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Flight Number",
    name: "Arrival_General_Private_Airport_Flight_Number",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },
  {
    //13
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Departure Airport",
    name: "Arrival_General_Private_Airport_Departure_Airport",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },
  {
    //14
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Arrival Airport",
    name: "Arrival_General_Private_Airport_Arrival_Airport",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },
  {
    //15
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Arrival Terminal",
    name: "Arrival_General_Private_Airport_Arrival_Terminal",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },
  {
    //16
    Page: "SummerArrivalDeparture",
    TextField: "TimeFieldForObjectState",
    label: "Airport Arrival/ Landing Time",
    name: "Arrival_General_Private_Airport_Arrival_Time",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Arrival_General_Arrival_Method",
    AiportType: "Arrival_General",
  },

  //--------------------------------------------------------------------------
  //Departure Aiport
  {
    //17
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Airline",
    name: "Departure_Airport_Airline",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
  },
  {
    //18
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Flight Number",
    name: "Departure_Airport_Flight_Number",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
  },
  {
    //19
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Destination Airport",
    name: "Departure_Airport_Destination_Airport",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
  },
  {
    //20
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Departure Airport",
    name: "Departure_Airport_Departure_Airport",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
    selectValues: ["Heathrow Airport"],
  },
  {
    //21
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Departure Terminal",
    name: "Departure_Airport_Departure_Terminal",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
    selectValues: ["Terminal 2", "Terminal 3", "Terminal 4", "Terminal 5"],
  },
  {
    //22
    Page: "SummerArrivalDeparture",
    TextField: "TimeFieldForObjectState",
    label: "Aiport Departure/ Take-Off Time",
    name: "Departure_Airport_Departure_Time",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
  },
  {
    //23
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Unaccompanied Minor Scheme",
    name: "Departure_Airport_Unaccompanied_Minor_Scheme",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_Airport",
    selectValues: ["Yes", "No"],
    AboveText: (
      <p>Is the student using an airline unaccompanied minor scheme?</p>
    ),
  },

  //--------------------------------------------------------------------------
  //Departure General

  {
    //24
    Page: "SummerArrivalDeparture",
    TextField: "SelectFieldForObjectState",
    label: "Departure Method",
    name: "Departure_General_Departure_Method",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_General",
    selectValues: [
      "Parent/ Guardian pick up",
      "Student departing on their own",
      "Private Airport Transfer",
    ],
  },
  //If Parent/ Guardian drop off is selected, show the following fields:
  {
    //25
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Full Name of Parent/Guardian",
    name: "Departure_General_Arrival_Parent_Guardian_Name",
    onlyAppearIfValueIs: ["Parent/ Guardian pick up"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },
  {
    //26
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Relationship to student",
    name: "Departure_General_Arrival_Parent_Guardian_Relationship",
    onlyAppearIfValueIs: ["Parent/ Guardian pick up"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },

  //if Private Airport Transfer is selected, show the following fields:
  {
    //27
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Airline",
    name: "Departure_General_Private_Airport_Airline",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },
  {
    //28
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Flight Number",
    name: "Departure_General_Private_Airport_Flight_Number",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },
  {
    //29
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Departure Airport",
    name: "Departure_General_Private_Airport_Departure_Airport",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },
  {
    //30
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Departure Terminal",
    name: "Departure_General_Private_Airport_Departure_Terminal",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },
  {
    //31
    Page: "SummerArrivalDeparture",
    TextField: "TimeFieldForObjectState",
    label: "Departure Time From Accomodation",
    name: "Departure_General_Departure_Time",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AiportType: "Departure_General",
  },
  {
    //32
    Page: "SummerArrivalDeparture",
    TextField: "TimeFieldForObjectState",
    label: "Flight Departure/ Take-Off Time",
    name: "Departure_General_Private_Airport_Departure_Time",
    onlyAppearIfValueIs: ["Private Airport Transfer"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Departure_General_Departure_Method",
    AiportType: "Departure_General",
  },
  //
  //Anything Else
  {
    //33
    Page: "SummerArrivalDeparture",
    TextField: "TextFieldForObjectState",
    label: "Anything else we need to know",
    name: "Travel_Notes",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
];
